export default {"theme":{"dark":false,"themes":{"light":{"primary":"#ff50a0","accent":"#FDECF8","secondary":"#BFA3CB","info":"#26a69a","warning":"#ffc107","error":"#dd2c00","success":"#00e676"}}}}
